"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AXIOS_DORA = exports.DORA_URL = void 0;
var axios_1 = __importDefault(require("axios"));
exports.DORA_URL = 'https://dora.coz.io';
var AXIOS_DORA = function (version) {
    var endpoint = '';
    if (version === 'neoLegacy') {
        endpoint = '/api/v1/neo2';
    }
    else if (version === 'neo') {
        endpoint = '/api/v1/neo3';
    }
    return axios_1["default"].create({
        baseURL: exports.DORA_URL + endpoint
    });
};
exports.AXIOS_DORA = AXIOS_DORA;
//# sourceMappingURL=index.js.map